import products from "./products.json";

/**
 * Fetch and hydrate Firestore bundle for the Store collection, with simple
 * localStorage-based freshness check and safe error handling.
 */
export const getStoreData = async () => {
  // Direct import, no fetch needed
  return products;
};
